const GOOGLE_SIGNUP_REDIRECT_KEY = 'lightmaster.google-signup.redirect';

export function isSafeAppRedirect(value: string | null | undefined): value is string {
  return Boolean(
    value?.startsWith('/')
      && !value.startsWith('//')
      && !value.startsWith('/auth/complete-profile'),
  );
}

export function saveGoogleSignupRedirect(value?: string | null): void {
  try {
    if (isSafeAppRedirect(value)) {
      sessionStorage.setItem(GOOGLE_SIGNUP_REDIRECT_KEY, value);
    } else {
      sessionStorage.removeItem(GOOGLE_SIGNUP_REDIRECT_KEY);
    }
  } catch {
    // Storage can be unavailable in privacy modes. '/' remains a safe fallback.
  }
}

export function consumeGoogleSignupRedirect(): string {
  try {
    const value = sessionStorage.getItem(GOOGLE_SIGNUP_REDIRECT_KEY);
    sessionStorage.removeItem(GOOGLE_SIGNUP_REDIRECT_KEY);
    return isSafeAppRedirect(value) ? value : '/';
  } catch {
    return '/';
  }
}
